// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal backdrop */
.T5q04j {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--neutral-dark-opacity-50);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: var(--spacing-3);
}

/* Modal container */
.w4mQFu {
  background: var(--background-white);
  border-radius: var(--card-border-radius);
  box-shadow: var(--card-box-shadow);
  border: 1px solid var(--stroke-neutral-subtle);
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow: auto;
  display: flex;
  flex-direction: column;
}

/* Header section */
.d3RvNG {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: var(--spacing-1);
  padding: var(--spacing-3) var(--spacing-3) 0;
}

.TUnmkW {
  font-family: var(--font-family-base);
  font-size: var(--type-title-lg-font-size);
  font-weight: var(--type-title-lg-font-weight);
  line-height: var(--type-title-lg-line-height);
  color: var(--text-neutral-dark);
  margin: 0;
  flex: 1;
}

.nDXIxC {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}

/* Content section */
.yBYmok {
  padding: var(--spacing-3) var(--spacing-3) 0;
}

.ba0pf4 {
  font-family: var(--font-family-base);
  font-size: var(--type-paragraph-md-font-size);
  font-weight: var(--type-paragraph-md-regular-font-weight);
  line-height: var(--type-paragraph-md-regular-line-height);
  color: var(--text-neutral-dark);
  margin: 0;
}

/* Actions section */
.A7Lg1k {
  display: flex;
  justify-content: stretch;
  align-items: stretch;
  gap: var(--spacing-2);
  padding: var(--spacing-3);
}

.oJWREb,
.atQz4u {
  flex: 1;
}

.oJWREb {
  border: 2px solid var(--stroke-primary-medium);
}

.atQz4u {
  background-color: var(--surface-primary-medium);
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .w4mQFu {
    margin: var(--spacing-2);
    max-width: none;
  }

  .A7Lg1k {
    flex-direction: column;
  }

  .oJWREb,
  .atQz4u {
    flex: none;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/ChargeCancelModal/ChargeCancelModal.module.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gDAAgD;EAChD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,mCAAmC;EACnC,wCAAwC;EACxC,kCAAkC;EAClC,8CAA8C;EAC9C,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,6CAA6C;EAC7C,6CAA6C;EAC7C,+BAA+B;EAC/B,SAAS;EACT,OAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;EAC7C,yDAAyD;EACzD,yDAAyD;EACzD,+BAA+B;EAC/B,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,OAAO;AACT;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,+CAA+C;AACjD;;AAEA,2BAA2B;AAC3B;EACE;IACE,wBAAwB;IACxB,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,UAAU;EACZ;AACF","sourcesContent":["/* Modal backdrop */\n.backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: var(--neutral-dark-opacity-50);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: var(--spacing-3);\n}\n\n/* Modal container */\n.modal {\n  background: var(--background-white);\n  border-radius: var(--card-border-radius);\n  box-shadow: var(--card-box-shadow);\n  border: 1px solid var(--stroke-neutral-subtle);\n  width: 100%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Header section */\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  gap: var(--spacing-1);\n  padding: var(--spacing-3) var(--spacing-3) 0;\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-size: var(--type-title-lg-font-size);\n  font-weight: var(--type-title-lg-font-weight);\n  line-height: var(--type-title-lg-line-height);\n  color: var(--text-neutral-dark);\n  margin: 0;\n  flex: 1;\n}\n\n.closeButton {\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n}\n\n/* Content section */\n.content {\n  padding: var(--spacing-3) var(--spacing-3) 0;\n}\n\n.description {\n  font-family: var(--font-family-base);\n  font-size: var(--type-paragraph-md-font-size);\n  font-weight: var(--type-paragraph-md-regular-font-weight);\n  line-height: var(--type-paragraph-md-regular-line-height);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n/* Actions section */\n.actions {\n  display: flex;\n  justify-content: stretch;\n  align-items: stretch;\n  gap: var(--spacing-2);\n  padding: var(--spacing-3);\n}\n\n.cancelButton,\n.confirmButton {\n  flex: 1;\n}\n\n.cancelButton {\n  border: 2px solid var(--stroke-primary-medium);\n}\n\n.confirmButton {\n  background-color: var(--surface-primary-medium);\n}\n\n/* Responsive adjustments */\n@media (max-width: 600px) {\n  .modal {\n    margin: var(--spacing-2);\n    max-width: none;\n  }\n\n  .actions {\n    flex-direction: column;\n  }\n\n  .cancelButton,\n  .confirmButton {\n    flex: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backdrop": `T5q04j`,
	"modal": `w4mQFu`,
	"header": `d3RvNG`,
	"title": `TUnmkW`,
	"closeButton": `nDXIxC`,
	"content": `yBYmok`,
	"description": `ba0pf4`,
	"actions": `A7Lg1k`,
	"cancelButton": `oJWREb`,
	"confirmButton": `atQz4u`
};
module.exports = ___CSS_LOADER_EXPORT___;
